/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_DateInputs */

const vi_tea_lot_date = /** @type {(inputs: Tea_Lot_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày lập lô`)
};

/**

* @param {Tea_Lot_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_date = /** @type {((inputs?: Tea_Lot_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_date(inputs)
});